import { Button } from "@mui/material";
import { IButtons } from "./Types/Buttons.types";
import { getButtonSx, mergeSx } from "./buttonStyles";

export const ButtonTertiary = ({
  size = "sm",
  sx,
  sxButton,
  iconOnly,
  tooltip,
  ...props
}: IButtons) => (
  <Button
    disableRipple
    {...props}
    sx={mergeSx((theme) => getButtonSx(theme, "tertiary", size), sx, sxButton)}
  />
);
